export default __webpack_public_path__ + "static/media/sunsetprof.546aac99.jp2";